import {Loader} from "@googlemaps/js-api-loader";
import pin from "../../img/icons/small/pin.svg";
import clusterPin from "../../img/icons/small/cluster-pin.svg";
import {MarkerClusterer} from "@googlemaps/markerclusterer";

export default class Map {

	static getHolderSelectors = () => ['.map-element-disabled'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {google.maps.Map} */
	#map;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		const mapElement = this.#holderElement.querySelector('.map');
		const hiddenPlaces = this.#holderElement.querySelector('.hidden-places-list').querySelectorAll('.hidden-place');
		let center = { lat: -27.467534295350724, lng: 153.02410529597566 };

		const mapOptions = {
			zoom: 8,
			maxZoom: 15,
			center: center,
			styles: [{"featureType":"landscape.man_made","elementType":"all","stylers":[{"color":"#faf5ed"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#bae5a6"}]},{"featureType":"road","elementType":"all","stylers":[{"weight":"1.00"},{"gamma":"1.8"},{"saturation":"0"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"hue":"#ffb200"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"lightness":"0"},{"gamma":"1"}]},{"featureType":"transit.station.airport","elementType":"all","stylers":[{"hue":"#b000ff"},{"saturation":"23"},{"lightness":"-4"},{"gamma":"0.80"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#a0daf2"}]}],
			disableDefaultUI: true
		};

		const loader = new Loader({
			apiKey: window.config.googleMapsApiKey,
			version: 'weekly',
		});

		loader.importLibrary('maps').then(({Map}) => {
			this.#map = new Map(mapElement, mapOptions);
			return this.#setMarkers(loader, hiddenPlaces);
		});
	}

	/**
	 * @param {Loader} loader
	 * @param {NodeListOf<Element>} hiddenPlaces
	 */
	async #setMarkers(loader, hiddenPlaces) {
		const {LatLngBounds} = await loader.importLibrary('core');
		const {Marker} = await loader.importLibrary('marker');
		await window.loadScript('snazzyInfoWindow');
		await window.loadScript('mapCluster');

		const bounds = new LatLngBounds();
		let map = this.#map;
		let markers = [];
		let categoriesMarkersList = [];
		categoriesMarkersList['category-all'] = [];

		const algorithmOptions = {maxZoom: 10};
		const renderer = {
			render: ({ count, position }) => new google.maps.Marker({
				label: {
					text: String(count),
					color: "#fff",
					fontSize: "18px",
					fontWeight: "normal",
					textAlign: "center",
					width: "54",
					height:"54"
				},
				icon: clusterPin,
				position: position,
				map: map,
				zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
				styles: [{ anchorText:[2,22]}]
			}),
		};

		hiddenPlaces.forEach((place) => {
			const location = {lat: parseFloat(place.dataset.latitude), lng: parseFloat(place.dataset.longitude)};
			bounds.extend(location);

			let marker = new Marker({
				position: location,
				map: map,
				icon: pin,
				title: place.dataset.title,
			});

			new SnazzyInfoWindow({
				marker: marker,
				content: this.#getMarkerContent(place),
				closeWhenOthersOpen: true,
			});

			place.dataset.categories.split(',').forEach(category => {
				if (category !== '') {
					if (categoriesMarkersList[category] === undefined) {
						categoriesMarkersList[category] = [];
					}
					categoriesMarkersList[category].push(marker);
				}
			});

			categoriesMarkersList['category-all'].push(marker);
			markers.push(marker);
		});

		this.#holderElement.querySelectorAll('.category').forEach(category => {
			category.addEventListener('click', () => {
				const filteredBounds = new LatLngBounds();
				this.#holderElement.querySelector('.current').classList.remove('current');
				category.classList.add('current');
				let selectedCategoryID = category.dataset.category;

				if (categoriesMarkersList[selectedCategoryID]) {
					markers.forEach(marker => {
						if (categoriesMarkersList[selectedCategoryID].indexOf(marker) > -1) {
							marker.setVisible(true);
							filteredBounds.extend(marker.getPosition());
						} else {
							marker.setVisible(false);
						}
					});

					map.fitBounds(filteredBounds);
				} else {
					markers.forEach(marker => {
						marker.setVisible(false);
					});

					map.fitBounds(bounds);
				}
			});
		})

		map.fitBounds(bounds);
		new MarkerClusterer({map, markers, algorithmOptions, renderer });
	}

	/**
	 * @param {Element} place
	 * @return {string}
	 */
	#getMarkerContent(place) {
		const content = [];
		content.push('<div class="row marker-content">');
		content.push('<div class="col marker-snazzy-info">');
		content.push('<h6>');
		content.push(place.dataset.title);
		content.push(`</h6>`);
		place.dataset.address && content.push('<p>' + place.dataset.address + '</p>');
		place.dataset.link && content.push('<a href="' + place.dataset.link + '" target="_blank">');
		place.dataset.link && content.push(`Get directions`);
		place.dataset.link && content.push(`</a>`);
		content.push(`</div>`);
		content.push(`</div>`);
		return content.join('');
	}

}
